import React from 'react';
import { Card, Button, Typography, withStyles } from '@material-ui/core';
import ArrowLeft from '@material-ui/icons/ArrowLeft';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ProjectListCycle from './ProjectListCycle';
import Upload from '@material-ui/icons/CloudUpload';
import Dropzone from 'react-dropzone';
import { getNumberOfActiveTasksInProject } from '../../firebase/db';
import { getNumberOfMyOpenTasksOnProject } from '../../firebase/db/project';
import { uploadProjectPicture } from '../../firebase/storage';
import { MAIN_COLOR } from '../../firebase-config';
import { toast } from 'react-toastify';
const styles = theme => ({
    card: {
        width: '87%',
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden'
    },
    root: {
        width: '100%',
        marginLeft: 20,
        borderBottom: '1px solid' + MAIN_COLOR,
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        width: '80%',
        minHeight: 120,
    },
    projectImage: {
        width: '204px',
        height: '184px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    projectNoImage: {
        width: '204px',
        height: '184px',
        backgroundColor: '#DCDCDC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        flexDirection: 'column',
    },
    wholeCard: {
        display: 'flex',
        flexDirection: 'row',
        margin: 20,
        width: '100%',
        minHeight: 120,
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        overflowX: 'hidden'
    },
    cardContent1: {
        width: 160,
        minWidth: 160,
        borderRight: '1px solid #b4b4b4',
        margin: '10px 0',
        minHeight: '100px',
        padding: '0 15px'
    },
    title: {
        padding: '5px 10px'
    },
    button: {
        width: 30,
        height: 120,
        backgroundColor: '#DCDCDC',
        cursor: 'pointer',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: 5
    }

});
class ProjectList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numberOfCycles: null,
            numberOfTasks: null
        };
        this.leftRef = React.createRef();
        this.rightRef = React.createRef();
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        const { projectId, auth } = this.props;
        if (this.props.role !== 'worker') {
            getNumberOfActiveTasksInProject(projectId)
                .then((numberOfTasks) => this.setState({ numberOfTasks }, () => console.log(this.state)));
        } else {
            getNumberOfMyOpenTasksOnProject(projectId, auth.email)
                .then((numberOfTasks) => {
                    console.log(numberOfTasks);
                    this.setState({ numberOfTasks }, () => console.log(this.state));
                });
        }
        this.leftRef.addEventListener("click", this.handleLeftClick);
        this.rightRef.addEventListener("click", this.handleRightClick);
    }

    handleRightClick = () => {
        const { index } = this.props;
        var button = document.getElementById(`right${index}`);
        button.onclick = function () {
            document.getElementById(`${index}`).scrollLeft += 75;
        };
    }

    handleLeftClick = () => {
        const { index } = this.props;
        var button = document.getElementById(`left${index}`);
        button.onclick = function () {
            document.getElementById(`${index}`).scrollLeft -= 75;
        };
    }

    handleDropPicture = ({ accepted, rejected }) => {
        const { projectId } = this.props;
        if (rejected.length > 0) {
            toast.error("Unsuported file type or file too large!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (!!accepted && accepted.length !== 0) {
            uploadProjectPicture(projectId, accepted[0])
        }
    }

    render() {
        const { title, searchValue, projectId, onWorkerViewTasks, projectCycles, onCreateUXCycleClick, classes, startDate, endDate, projectImage, onContinueSetupClick, index } = this.props;
        const numberOfCycles = (projectCycles && projectCycles.cycles) ? Object.keys(projectCycles.cycles).length : 0;
        const { numberOfTasks } = this.state;
        const renderCycles = () => {
            return (projectCycles && projectCycles.cycles) ? Object.keys(projectCycles.cycles).map((cycle, i) => {
                return (
                    <ProjectListCycle
                        key={cycle}
                        projectCycle={projectCycles.cycles[cycle]}
                        cycleId={cycle}
                        projectId={projectId}
                        onCreateUXCycleClick={onCreateUXCycleClick}
                        onWorkerViewTasks={() => onWorkerViewTasks(projectId, cycle, numberOfTasks)}
                    />
                )

            }) : null;
        };

        return (
            (!searchValue || title.toLowerCase().includes(searchValue.toLowerCase()))
            &&
            <div className={classes.column}>
                <div className={classes.wholeCard}>
                    <Dropzone
                        accept={['image/jpeg', 'image/png', 'image/bmp', 'image/svg+xml', 'image/gif']}
                        maxSize={10485760}
                        multiple={false}
                        className="dropZone-profile"
                        onDrop={(accepted, rejected) => this.handleDropPicture({ accepted, rejected })}
                    >
                        {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                            return projectImage ?
                                <img className={classes.projectImage}
                                    src={projectImage}
                                /> : (
                                    <div className={classes.projectNoImage}>
                                        <img src={require('../../icons/image_upload.svg')} height="50" width="50" style={{ paddingTop: 40 }} alt="Manager" />
                                        <Typography style={{ paddingTop: 20 }}>Klicken um Bild hochzuladen</Typography>
                                    </div>
                                )
                        }}
                    </Dropzone>
                    <Card className={classes.card}>
                        <Typography variant="headline" className={classes.title} >{title}</Typography>
                        <div className={classes.cardContent}>
                            <div className={classes.cardContent1}>
                                <Typography variant="subheading" >
                                    {`Start: ${startDate ? (new Date(startDate)).toLocaleDateString('de-AT') : ''}`}
                                </Typography>
                                <Typography variant="subheading" >
                                    {`Ende: ${endDate ? (new Date(endDate)).toLocaleDateString('de-AT') : ''}`}
                                </Typography>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                                >
                                    <img src={require('../../icons/cycle.svg')} height="20" width="20" alt="Manager" />
                                    <Typography style={{ marginLeft: 10 }}>
                                        {numberOfCycles}
                                    </Typography>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                                >
                                    <img src={require('../../icons/gear.svg')} height="20" width="20" alt="Manager" />
                                    <Typography style={{ marginLeft: 10 }}>
                                        {numberOfTasks}
                                    </Typography>
                                </div>
                                <Button size="small" color="primary" onClick={onContinueSetupClick}>
                                    Projekt Setup
                            </Button>
                            </div>
                            <div className={classes.button} ref={elem => this.leftRef = elem} id={`left${index}`} ><ArrowLeft /></div>
                            <div id={index} className="cycleContainer">
                                {renderCycles()}
                            </div>
                            <div className={classes.button} ref={elem => this.rightRef = elem} id={`right${index}`} ><ArrowRight /></div>
                        </div>
                    </Card>
                </div>
                {
                    index === 0 &&
                    <div className={classes.root}></div>
                }
            </div>
        );
    }
}

export default withStyles(styles)(ProjectList);



// WEBPACK FOOTER //
// ./src/components/common/ProjectList.js